import request from '@/units/request';

export default {
  list: (params) =>
    request({
      url: 'category/index',
      method: 'GET',
      params,
    }),

  indexData: (params) =>
    request({
      url: 'index/indexData',
      method: 'GET',
      params,
    }),
};
